import { PageModel } from "./PageModel";

class DetailProjectsController extends PageModel {
}

export { DetailProjectsController }
